import adaloLogoType from '../App/logo.svg'

import './Onboarding.scss'

const AdaloLogotype = (): JSX.Element => (
  <img className="adalo-logotype" src={adaloLogoType} alt="Adalo logo" />
)

export default AdaloLogotype
